module.exports = __webpack_public_path__ + "static/media/branding-img2.f091ad55.jpg";